import './accordion.scss'

import { FC, useState } from 'react'
import { Collapse, Image, Row } from 'react-bootstrap'
import { plus_icon } from 'src/assets'
import { accordion_t } from 'src/types'
import { join_str } from 'src/utils'

export const Accordion: FC<accordion_t> = ({
  title,
  head,
  children,
  expanded: expanded_ = false,
  classes,
  classes_head = 'm-0 p-0 justify-content-between align-items-center flex-nowrap width-fit-content',
  classes_title = 'm-0 p-0 mr-2 font-18',
  classes_icon = 'accordion--icon',
  on_toggle,
}: accordion_t) => {
  const [expanded, set_expanded] = useState(expanded_)
  const exp = on_toggle ? expanded_ : expanded
  return (
    <main className={classes}>
      {/* HEAD */}
      <Row
        className={classes_head}
        role="button"
        onClick={() => {
          on_toggle?.()
          set_expanded(!expanded)
        }}
      >
        {head || <p className={classes_title}>{title}</p>}
        <Image src={plus_icon} className={join_str(exp ? 'accordion--rotate' : '', classes_icon)} />
      </Row>

      {/* COLLAPSIBLE */}
      <Collapse in={exp}>
        <div className="m-0 p-0">{children}</div>
      </Collapse>
    </main>
  )
}
